interface Window {
  phpProps: object;
  videojs: Function;
}
const am = {
  mobileThresh: 1120,
  scrollThresh: 100,
  adDelay: 3000,
  domReadyRan: false,
  isDevDomain: false,
  isSingle: false,
  isMobileDevice: false,
  isMobileWidth: false,
  constructor() {
    am.importPropsPHP();
    am.detectMobileWidth();
    am.detectMobileDevice();
    window.addEventListener('resize', am.detectMobileWidth);
    am.domReady(() => {
      if (!am.domReadyRan) {
        am.setupMenu();
        am.detectThresh();
        am.setupStickyFooter();
        am.setupBreakingAlerts();
        am.setupCopyLink();
        if (am.isSingle) am.pChecker();
        am.setupCarousel();
        am.setupGallery();
        am.setupSubmenus();
        am.setupSearchToggle();
        am.setupLazyLoader();
        am.generateNewsKeywords();
        am.wrapVideoIframes();
        am.cleanupPostContentForTaboola();
        am.setupVideoPlayer();
      }
      am.domReadyRan = true;
    });
  },
  detectMobileDevice() {
    const isMobileDevice = !!navigator.userAgent.match(/mobi/i);
    if (isMobileDevice) {
      am.domReady(() => document.body.classList.add('is-mobile-device'));
      am.log('mobile browser detected');
    } else am.log('not a mobile browser');
    am.isMobileDevice = isMobileDevice;
    return isMobileDevice;
  },
  detectMobileWidth() {
    const isMobileWidth = window.innerWidth <= am.mobileThresh;
    if (isMobileWidth) {
      am.domReady(() => document.body.classList.add('is-mobile-width'));
      am.log('mobile width detected');
    } else am.log('not mobile width');
    am.isMobileWidth = isMobileWidth;
    return isMobileWidth;

  },
  detectThresh() {

    // Setup =====================================================================

    const body = document.body;
    const widthThresh = 1140;
    const scrollThreshClass = 'is-scrolled';
    const widthThreshClass = 'is-mobile-width';

    // Tests
    const isBeyondScrollThresh = () => window.scrollY >= am.scrollThresh;
    const isBeyondWidthThresh = () => window.innerWidth >= widthThresh;

    // Results
    const threshCrossed = {
      scroll: isBeyondScrollThresh(),
      width: isBeyondWidthThresh()
    };

    // Functions =================================================================

    function initCheck() {
      if (threshCrossed.scroll) body.classList.add(scrollThreshClass);
      else body.classList.remove(scrollThreshClass);
      if (threshCrossed.width) body.classList.remove(widthThreshClass);
      else body.classList.add(widthThreshClass);
    }

    function eventCheck(threshTest, threshType, threshStateClass) {
      const beyondThresh = threshTest();
      const crossingBeyond = beyondThresh && !threshCrossed[threshType];
      const crossingWithin = !beyondThresh && threshCrossed[threshType];
      if (crossingBeyond || crossingWithin) {
        threshCrossed[threshType] = !threshCrossed[threshType];
        am.log(threshCrossed);
        body.classList.toggle(threshStateClass);
      }
    }

    // Actions ===================================================================

    initCheck();
    window.addEventListener('scroll',
      eventCheck.bind(am, isBeyondScrollThresh, 'scroll', scrollThreshClass)
    );
    window.addEventListener('resize',
      eventCheck.bind(am, isBeyondWidthThresh, 'width', widthThreshClass)
    );
  },
  domReady(callback) {
    const stillLoading = document.readyState === 'loading';
    if (stillLoading) document.addEventListener('DOMContentLoaded', callback);
    else callback();
  },
  generateNewsKeywords() {
    const keywordsMeta = document.querySelector<HTMLMetaElement>('meta[name=keywords]');
    if (keywordsMeta) {
      const newsKeywordsMeta = document.createElement('meta');
      newsKeywordsMeta.name = 'news_keywords';
      newsKeywordsMeta.content = keywordsMeta.content;
      const keywordsMetaParent = keywordsMeta.parentNode!;
      keywordsMetaParent.insertBefore(newsKeywordsMeta, keywordsMeta);
    }
  },
  group(message: string, ...styles: string[]) {
    const notDisabledOnDev = am.isDevDomain && am.urlParams['debug'] !== 'off';
    const enabledOnProd = am.urlParams['debug'] === 'on';
    if (notDisabledOnDev || enabledOnProd) {
      // eslint-disable-next-line no-console
      console.group(message, ...styles);
    }
  },
  groupEnd() {
    const notDisabledOnDev = am.isDevDomain && am.urlParams['debug'] !== 'off';
    const enabledOnProd = am.urlParams['debug'] === 'on';
    if (notDisabledOnDev || enabledOnProd) {
      // eslint-disable-next-line no-console
      console.groupEnd();
    }
  },
  getWinThresh(minThresh: number, fullThresh: number) {
    const width = window.innerWidth;
    let size;
    if (width >= minThresh && width <= fullThresh) {
      size = 'medium';
    } else if (width > fullThresh) {
      size = 'full';
    } else if (width < minThresh) {
      size = 'small';
    } else {
      size = 'unknown';
    }
    am.log('Window Thresh is: ' + size);
    return size;
  },
  importPropsPHP() {
    for (const prop in window.phpProps) {
      if (Object.prototype.hasOwnProperty.call(window.phpProps, prop)) {
        am[prop] = window.phpProps[prop];
      }
    }
  },
  loadScript(uri: string, onloadCallback, onerrorCallback: OnErrorEventHandler) {
    const scriptEl = document.createElement('script');
    scriptEl.src = uri;
    scriptEl.async = true;
    if (typeof onloadCallback === 'function') scriptEl.onload = onloadCallback;
    if (typeof onerrorCallback === 'function') scriptEl.onerror = onerrorCallback;
    const firstScriptEl = document.getElementsByTagName('script')[0];
    firstScriptEl.parentNode!.insertBefore(scriptEl, firstScriptEl);
  },
  loadAsset(filename: string, callback: Function | undefined = undefined) {
    const fileExtensions = filename.match(/\.[0-9a-z]+$/i);
    if (!fileExtensions) {
      am.log(`No file extension found for asset ${filename}`);
      return;
    }
    const fileExtension = fileExtensions[0];
    let element;
    if (fileExtension === '.js') {
      // Check if already added
      const existingScriptElement = document.querySelector(`script[src="${filename}"]`);
      if (existingScriptElement !== null) {
        am.log('Script already added');
        if (callback) element.onload = () => callback();
        return;
      }
      // Add to document head
      element = document.createElement('script');
      element.setAttribute('async', true);
      element.setAttribute('src', filename);
      if (callback) element.onload = callback;
    } else if (fileExtension === '.css') {
      // Check if already linked
      const existingLinkElement = document.querySelector(`link[href="${filename}"]`);
      if (existingLinkElement !== null) {
        am.log('Stylesheet already linked');
        return;
      }
      // Add to document head
      element = document.createElement('link');
      element.setAttribute('rel', 'stylesheet');
      element.setAttribute('type', 'text/css');
      element.setAttribute('href', filename);
    }
    if (typeof element !== 'undefined') {
      document.getElementsByTagName('head')[0].appendChild(element);
    }
  },
  log(message: (string | object), ...styles: (string | undefined)[]) {
    const notDisabledOnDev = am.isDevDomain && am.urlParams['debug'] !== 'off';
    const enabledOnProd = am.urlParams['debug'] === 'on';
    if (notDisabledOnDev || enabledOnProd) {
      // eslint-disable-next-line no-console
      console.log(message, ...styles);
    }
  },
  maxHeader() {
    const header = document.querySelector('header')!;
    if (header.classList.contains('compact')) {
      am.log('maximizing header');
      header.classList.remove('compact');
      header.classList.add('full');
    }
  },
  minHeader() {
    const header = document.querySelector('header')!;
    if (header.classList.contains('full')) {
      am.log('minimizing header');
      header.classList.remove('full');
      header.classList.add('compact');
    }
  },
  pChecker() {
    const postBody = document.querySelector('.o-post-wrap');
    if (!postBody) return;
    postBody.querySelectorAll('p').forEach(p => {
      if (!p.innerText) p.classList.add('o-no-text');
    });
  },
  populateGet() {
    const obj = {}, params = location.search.slice(1).split('&');
    for (let i = 0, len = params.length;i < len;i++) {
      const keyVal = params[i].split('=');
      obj[decodeURIComponent(keyVal[0])] = decodeURIComponent(keyVal[1]);
    }
    am.log(obj);
    return obj;
  },
  cleanupPostContentForTaboola() {
    // Get the post body container
    const postBody = document.getElementById('post-body');
    if (!postBody) return;

    // Get all children
    const children = Array.from(postBody.children);
    
    // Process paragraphs from the end until we hit meaningful content
    // This ensures we only remove empty paragraphs at the end of the post
    for (let i = children.length - 1; i >= 0; i--) {
      const element = children[i];
      
      // Only process paragraphs - stop if we hit any other element type
      if (element.tagName !== 'P') break;
      
      // Check if the paragraph has any text content or embedded media
      const hasText = element.textContent?.trim();
      const hasEmbeds = element.querySelector('iframe, img, video, embed');
      
      if (!hasText && !hasEmbeds) {
        element.remove();
      } else {
        // Stop when we hit any non-empty content
        break;
      }
    }
    
    // After cleanup, handle callout positioning
    const updatedChildren = Array.from(postBody.children);
    const lastElement = updatedChildren[updatedChildren.length - 1];
    if (!lastElement?.classList?.contains('o-callout')) return;
    
    // Find a substantial paragraph (100+ chars) to place the callout before
    let insertIndex = -1;
    for (let i = updatedChildren.length - 2; i >= 0; i--) {
      const element = updatedChildren[i];
      if (element.tagName === 'P' && element.textContent.length >= 100) {
        insertIndex = i;
        break;
      }
    }
    
    // Move the callout if we found a suitable location
    if (insertIndex !== -1) {
      const targetElement = updatedChildren[insertIndex];
      targetElement.parentNode.insertBefore(lastElement, targetElement);
    }
  },
  setupStickyFooter() {
    const btn = document.querySelector<HTMLButtonElement>('.closeme-button');
    if (!btn) return;
    btn.addEventListener('click', () => {
      const content = document.querySelector<HTMLElement>('.stickyfooter-content');
      if (content) content.classList.add('bottom');
    });
  },
  setupBreakingAlerts() {
    const button = document.querySelector('.c-close-breaking-alert-btn');
    if (button) {
      button.addEventListener('click', () => {
        document.querySelector('.c-breaking-alert')!.classList.add('is-collapsed');
      });
    }
  },
  setupCarousel() {
    const carousel = document.getElementById('ctv-carousel');
    if (!carousel) return;
    const track = carousel.querySelector<HTMLElement>('.ctv-hero__track');
    if (!track) return;
    const bullets = carousel.querySelectorAll<HTMLElement>('.ctv-hero__bullet');
    const total = track.children.length;
    let current = 0;
    let interval: ReturnType<typeof setInterval>;

    function goTo(n: number) {
      loadDeferredImages();
      bullets[current].classList.remove('is-active');
      current = (n + total) % total;
      bullets[current].classList.add('is-active');
      track!.style.transform = `translateX(calc(-${current * 100}% - ${current * 20}px))`;
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }
    // Load deferred slide images before first transition
    let imagesLoaded = false;
    function loadDeferredImages() {
      if (imagesLoaded) return;
      imagesLoaded = true;
      track!.querySelectorAll<HTMLImageElement>('img[data-src]').forEach(img => {
        img.src = img.dataset.src!;
        img.removeAttribute('data-src');
      });
    }
    setTimeout(loadDeferredImages, 3000);

    // Once the user clicks an arrow or pip we treat them as taking manual
    // control and stop auto-advancing entirely for the rest of the page
    // load. The hover and visibility handlers below also call startAuto,
    // so the flag short-circuits those once interaction has happened.
    let userControlled = false;
    function startAuto() { if (!userControlled) interval = setInterval(next, 6000); }
    function stopAuto() { clearInterval(interval); }
    function takeManualControl() { userControlled = true; stopAuto(); }

    const rightArrow = carousel.querySelector('.ctv-hero__arrow--right');
    const leftArrow = carousel.querySelector('.ctv-hero__arrow--left');
    if (rightArrow) rightArrow.addEventListener('click', () => { takeManualControl(); next(); });
    if (leftArrow) leftArrow.addEventListener('click', () => { takeManualControl(); prev(); });

    bullets.forEach(b => {
      b.addEventListener('click', function() { takeManualControl(); goTo(parseInt(this.dataset.slide!)); });
    });

    carousel.addEventListener('mouseenter', stopAuto);
    carousel.addEventListener('mouseleave', startAuto);

    // Touch swipe
    let touchStartX = 0;
    let touchStartY = 0;
    let swiping = false;
    carousel.addEventListener('touchstart', (e: TouchEvent) => {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      swiping = false;
      stopAuto();
    }, { passive: true });
    carousel.addEventListener('touchmove', (e: TouchEvent) => {
      const dx = Math.abs(e.touches[0].clientX - touchStartX);
      const dy = Math.abs(e.touches[0].clientY - touchStartY);
      if (dx > dy && dx > 10) {
        swiping = true;
        e.preventDefault();
      }
    }, { passive: false });
    carousel.addEventListener('touchend', (e: TouchEvent) => {
      if (swiping) {
        const diff = touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 50) {
          if (diff > 0) next(); else prev();
        }
      }
      startAuto();
    });

    startAuto();

    document.addEventListener('visibilitychange', () => {
      document.hidden ? stopAuto() : startAuto();
    });
  },
  setupGallery() {
    const gallery = document.getElementById('ctv-gallery');
    if (!gallery) return;
    const mainImage = document.getElementById('ctv-gallery-image') as HTMLImageElement | null;
    const caption = document.getElementById('ctv-gallery-caption');
    const captionToggle = document.getElementById('ctv-gallery-caption-toggle') as HTMLButtonElement | null;
    if (!mainImage) return;

    const thumbs = Array.from(gallery.querySelectorAll<HTMLElement>('.c-article-gallery__thumb'));
    const viewport = gallery.querySelector<HTMLElement>('.c-article-gallery__viewport');

    // Bring a thumb into view by scrolling the strip and nothing else.
    // scrollIntoView would do this, but it scrolls every scrollable ancestor
    // including the page, and a wrap from the last thumb to the first is a
    // ~2300px glide that takes most of a second to settle — so a reader
    // clicking through quickly is fighting an animation the whole way. Long
    // jumps are therefore instant; only short steps animate.
    function revealThumb(thumb: HTMLElement) {
      if (!viewport) return;
      const view = viewport.getBoundingClientRect();
      const box = thumb.getBoundingClientRect();
      const pad = 8;

      let delta = 0;
      if (box.left < view.left) delta = box.left - view.left - pad;
      else if (box.right > view.right) delta = box.right - view.right + pad;
      else return; // already visible, leave the strip where the reader put it

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const longJump = Math.abs(delta) > viewport.clientWidth;
      const behavior: ScrollBehavior = (longJump || reduceMotion) ? 'auto' : 'smooth';
      viewport.scrollTo({ left: viewport.scrollLeft + delta, behavior });
    }

    // Captions are clamped to a fixed number of lines so the block keeps the
    // same height from image to image. The toggle only appears when there is
    // actually text hidden behind the clamp.
    // Whether the clamp is actually hiding anything depends on the column
    // width, so this has to re-run on resize as well as on image change —
    // otherwise a caption clipped by a narrower window has no way to expand.
    function syncToggle() {
      if (!caption || !captionToggle) return;
      // While expanded there is no clamp to measure, and the button is needed
      // to collapse again, so leave it alone.
      if (caption.classList.contains('is-expanded')) return;
      // Kept in the layout either way — only its visibility changes, so the
      // caption block is the same height whether or not there is more to read.
      const fits = caption.scrollHeight <= caption.clientHeight + 1;
      captionToggle.classList.toggle('is-invisible', fits);
      captionToggle.setAttribute('aria-hidden', fits ? 'true' : 'false');
      captionToggle.tabIndex = fits ? -1 : 0;
    }

    function refreshCaption() {
      if (!caption || !captionToggle) return;
      caption.classList.remove('is-expanded');
      captionToggle.textContent = 'Show more';
      syncToggle();
    }

    let captionResizeTimer: ReturnType<typeof setTimeout>;
    window.addEventListener('resize', () => {
      clearTimeout(captionResizeTimer);
      captionResizeTimer = setTimeout(syncToggle, 150);
    });

    if (caption && captionToggle) {
      captionToggle.addEventListener('click', () => {
        const expanded = caption.classList.toggle('is-expanded');
        captionToggle.textContent = expanded ? 'Show less' : 'Show more';
      });
      refreshCaption();
    }

    function show(index: number) {
      const thumb = thumbs[index];
      if (!thumb) return;
      thumbs.forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      mainImage!.src = thumb.dataset.full!;
      mainImage!.alt = thumb.dataset.alt || '';
      if (caption) {
        caption.textContent = thumb.dataset.caption || '';
        refreshCaption();
      }
      revealThumb(thumb);
    }

    thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => show(i)));

    // Arrows step the selection rather than just scrolling the strip, so the
    // main image always advances — that is what readers expect from them.
    function step(delta: number) {
      const current = thumbs.findIndex(t => t.classList.contains('is-active'));
      show((current + delta + thumbs.length) % thumbs.length);
    }

    gallery.querySelector('.c-article-gallery__arrow--left')?.addEventListener('click', () => step(-1));
    gallery.querySelector('.c-article-gallery__arrow--right')?.addEventListener('click', () => step(1));

    // Swipe the main image on touch devices
    let touchStartX = 0;
    let touchStartY = 0;
    mainImage.addEventListener('touchstart', (e: TouchEvent) => {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    }, { passive: true });
    mainImage.addEventListener('touchend', (e: TouchEvent) => {
      const dx = e.changedTouches[0].clientX - touchStartX;
      const dy = e.changedTouches[0].clientY - touchStartY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) step(dx < 0 ? 1 : -1);
    }, { passive: true });
  },
  setupSubmenus() {
    document.querySelectorAll('.c-menu-nav-list .has-subitems > .c-menu-nav-list__link').forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        (e.currentTarget as HTMLElement).parentElement?.classList.toggle('is-open');
      });
    });
  },
  setupSearchToggle() {
    const toggle = document.querySelector('.ctv-search-toggle');
    if (!toggle) return;
    toggle.addEventListener('click', () => {
      const form = document.querySelector('.ctv-header-search');
      if (!form) return;
      form.classList.toggle('is-open');
      if (form.classList.contains('is-open')) {
        form.querySelector<HTMLInputElement>('input')?.focus();
      }
    });
  },
  setupCopyLink() {
    const copyButton = document.querySelector<HTMLElement>('#copy-button');
    if (copyButton) {
      const copyUrl = copyButton.dataset.copyUrl;
      if (copyUrl) {
        const clickHandler = () => {
          navigator.clipboard.writeText(copyUrl);
          copyButton.classList.add('is-copied');
        };
        const transititonendHandler = () => {
          copyButton.classList.remove('is-copied');
        };
        copyButton.addEventListener('click', clickHandler);
        copyButton.addEventListener('transitionend', transititonendHandler);
      }
    }
  },
  setupLazyLoader() {

    // Setup ===================================================================

    const buffer = 50; // px
    const lazyParentClass = '.u-lazy-parent';
    const lazyChildClass = '.u-lazy-child';

    const lazyParents = document.querySelectorAll(lazyParentClass);
    const observable = 'IntersectionObserver' in window;
    const nativelyObservable = observable ? (/\{\s*\[native code\]\s*\}/).test('' + IntersectionObserver) : 0;


    // Behavior ===============================================================

    if (nativelyObservable) {
      const options = {
        root: null,
        rootMargin: buffer + 'px',
        threshold: 0
      };
      const observer = new IntersectionObserver(observationCallback, options);
      lazyParents.forEach(element => observer.observe(element));
    } else {
      lazyParents.forEach(element => {
        const lazyListener = () => lazyChecker(lazyListener, element as HTMLElement);
        window.addEventListener('scroll', lazyListener);
        lazyListener();
      });
    }


    // Functions ================================================================

    function lazyLoad(lazyParent: HTMLElement) {
      const lazyChildren = lazyParent.querySelectorAll(lazyChildClass);
      lazyChildren.forEach(lazyChild => {
        if (lazyChild.firstChild && lazyChild.firstChild.textContent) {
          lazyChild.insertAdjacentHTML('afterend', lazyChild.firstChild.textContent);
        }
        lazyChild.remove();
      });
    }

    function observationCallback(entries: IntersectionObserverEntry[], observer: IntersectionObserver) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          lazyLoad(entry.target as HTMLElement);
          observer.unobserve(entry.target);
          const id = entry.target.id || 'no id';
          am.log('%cLazy Observation Activated%c for%c ' + id, 'color: lime;', 'color: inherit;', 'color: PapayaWhip;');
        }
      });
    }

    function lazyChecker(listener: EventListener, lazyParent: HTMLElement) {
      const loadPoint = lazyParent.offsetTop - buffer;
      const bottomOfWindow = window.scrollY + window.innerHeight;
      if (bottomOfWindow >= loadPoint) {
        window.removeEventListener('scroll', listener);
        lazyLoad(lazyParent);
        am.log('%cLazy Check Activated%c for%c ' + lazyParent.id, 'color: gold;', 'color: inherit;', 'color: PapayaWhip;');
      }
    }
  },
  setupMenu() {
    const menu = document.querySelector('#menu')!;
    const menuBtn = document.querySelector('#menu-btn')!;
    const menuCloseModal = document.createElement('div');
    const menuFocusBreaks = document.querySelectorAll('.u-menu-focus-break');
    const handleMenuFocusBreak = () => {
      document.body.classList.add('has-closed-menu');
      menu.classList.add('is-closed-menu');
      menuCloseModal.classList.add('is-closed-menu-modal');
    };
    document.body.classList.add('has-closed-menu');
    menuCloseModal.id = 'menu-close-modal';
    menuCloseModal.classList.add('o-menu-close-modal');
    menuCloseModal.classList.add('c-menu-close-modal');
    menuCloseModal.classList.add('is-closed-menu-modal');

    menuBtn.addEventListener('click', toggleMenu);
    menuCloseModal.addEventListener('click', toggleMenu);

    function toggleMenu() {
      document.body.classList.toggle('has-closed-menu');
      menu.classList.toggle('is-closed-menu');
      menuCloseModal.classList.toggle('is-closed-menu-modal');
    }
    document.body.appendChild(menuCloseModal);
    menuFocusBreaks.forEach(el => {
      el.addEventListener('focus', handleMenuFocusBreak);
    });
  },
  wrapVideoIframes() {
    if (!document.body.classList.contains('is-home')) {
      const youtube = document.querySelectorAll('iframe[src*="youtube"]');
      const facebook = document.querySelectorAll('iframe[src*="facebook"]');
      if (youtube || facebook) {
        const addWrapper = element => {
          const responsiveWrap = document.createElement('div');
          responsiveWrap.classList.add('u-responsive-16x9-iframe-wrap');
          element.parentNode.insertBefore(responsiveWrap, element);
          responsiveWrap.appendChild(element);
        };
        youtube.forEach(element => addWrapper(element));
        facebook.forEach(element => addWrapper(element));
      }
    }
  },
  setupVideoPlayer() {
    if (!document.querySelector('.ctv-latest-videos')) return;

    const YT_EMBED = 'https://www.youtube-nocookie.com/embed/';
    const YT_PARAMS = '?autoplay=1&playsinline=1';
    const YT_ALLOW = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';

    function makeIframe(videoId: string, className: string): HTMLIFrameElement {
      const iframe = document.createElement('iframe');
      iframe.src = YT_EMBED + encodeURIComponent(videoId) + YT_PARAMS;
      iframe.allow = YT_ALLOW;
      iframe.allowFullscreen = true;
      iframe.setAttribute('frameborder', '0');
      iframe.className = className;
      return iframe;
    }

    function loadIntoPlayer(videoId: string, title: string) {
      const wrap = document.getElementById('ctv-player-wrap');
      if (!wrap) return;

      const img = document.createElement('img');
      img.src = `https://i.ytimg.com/vi/${videoId}/maxresdefault.jpg`;
      img.onerror = () => { img.src = `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`; };
      img.alt = title;
      img.className = 'ctv-hero-thumb__img';

      const heroDiv = document.createElement('div');
      heroDiv.className = 'ctv-stream-player__embed ctv-hero-thumb is-playing';
      heroDiv.dataset.videoId = videoId;
      heroDiv.dataset.title = title;
      heroDiv.appendChild(img);
      heroDiv.appendChild(makeIframe(videoId, 'ctv-hero-thumb__iframe'));

      const titleEl = document.createElement('p');
      titleEl.className = 'ctv-stream-player__title';
      titleEl.textContent = title;

      wrap.innerHTML = '';
      wrap.appendChild(heroDiv);
      wrap.appendChild(titleEl);
    }

    let activeLink: HTMLElement | null = null;

    document.addEventListener('click', (e: MouseEvent) => {
      const target = e.target as Element;

      // Hero thumbnail — click plays inline
      const hero = target.closest<HTMLElement>('.ctv-hero-thumb');
      if (hero && !hero.classList.contains('is-playing')) {
        e.preventDefault();
        hero.appendChild(makeIframe(hero.dataset.videoId!, 'ctv-hero-thumb__iframe'));
        hero.classList.add('is-playing');
        return;
      }

      // Grid card clicks
      const link = target.closest<HTMLElement>('.ctv-video-link');
      if (!link) return;
      e.preventDefault();

      const videoId  = link.dataset.videoId!;
      const title    = link.dataset.title!;
      const isMobile = window.innerWidth < am.mobileThresh;

      if (isMobile) {
        // Stop hero if playing
        const playingHero = document.querySelector<HTMLElement>('.ctv-hero-thumb.is-playing');
        if (playingHero) {
          playingHero.querySelector('.ctv-hero-thumb__iframe')?.remove();
          playingHero.classList.remove('is-playing');
        }
        // Collapse other expanded cards
        document.querySelectorAll<HTMLElement>('.ctv-latest-videos__card.is-expanded').forEach(c => {
          c.classList.remove('is-expanded');
          c.querySelector('.ctv-card-iframe')?.remove();
        });
        const card  = link.closest<HTMLElement>('.ctv-latest-videos__card')!;
        const thumb = card.querySelector('.ctv-latest-videos__thumb');
        if (thumb) thumb.appendChild(makeIframe(videoId, 'ctv-card-iframe'));
        card.classList.add('is-expanded');
      } else {
        loadIntoPlayer(videoId, title);
        const section = document.getElementById('ctv-player-section')!;
        const header  = document.querySelector<HTMLElement>('.o-header-core') || document.querySelector<HTMLElement>('.o-header');
        const headerH = header ? header.getBoundingClientRect().bottom : 0;
        if (section.getBoundingClientRect().top < headerH) {
          window.scrollTo({ top: window.scrollY + section.getBoundingClientRect().top - headerH - 10, behavior: 'smooth' });
        }
      }

      activeLink?.classList.remove('is-active');
      activeLink = link;
      link.classList.add('is-active');
    });
  },
  get urlParams() {
    const parsedParams = {};
    const urlParams = location.search.slice(1).split('&');
    urlParams.forEach(keyValString => {
      const keyValArray = keyValString.split('=');
      const key = decodeURIComponent(keyValArray[0]);
      const val = decodeURIComponent(keyValArray[1]);
      parsedParams[key] = val;
    });
    return parsedParams;
  }
};
am.constructor();
